import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ApiService } from '@shared/services/api.service'
import { DocumentInput, DocumentItem, DocumentRecord } from './document.model'
import { toFormData } from '@core/helpers/to-form-data'
import { InputDuplicateData } from '@app/shared/models/duplicate-dialog.model'
import { withFeedback } from '@app/core/interceptors/feedback-context'
@Injectable({ providedIn: 'root' })
export class DocumentService {
  constructor(private apiService: ApiService) {}

  get(id: number): Observable<DocumentItem> {
    return this.apiService.get(`/documents/${id}`).pipe(
      map((data) => data['data'] as DocumentItem),
      map((documentItem: DocumentItem) => new DocumentItem(documentItem)),
    )
  }

  edit(id: number, document: DocumentInput): Observable<DocumentItem> {
    return this.apiService
      .post(`/documents/${id}`, toFormData(document), { context: withFeedback() })
      .pipe(map((data) => data['data'] as DocumentItem))
  }

  editRecord(documentId: number, recordId: number, record: DocumentRecord): Observable<DocumentRecord> {
    return this.apiService.post(`/documents/${documentId}/record/${recordId}`, toFormData(record), { context: withFeedback() })
  }

  create(document: DocumentInput): Observable<DocumentItem> {
    return this.apiService
      .post('/documents', toFormData(document), { context: withFeedback() })
      .pipe(map((data) => data['data'] as DocumentItem))
  }

  delete(id: number) {
    return this.apiService.delete(`/documents/${id}`, { context: withFeedback() })
  }

  archive(id: number) {
    return this.apiService.patch(`/documents/${id}/archive`, {}, { context: withFeedback() })
  }

  restore(id: number) {
    return this.apiService.patch(`/documents/${id}/restore`, {}, { context: withFeedback() })
  }

  duplicate(id: number, inputDuplicateData: InputDuplicateData) {
    return this.apiService.post(`/documents/${id}/duplicate`, inputDuplicateData, { context: withFeedback() })
  }
}
